import * as uniqBy from 'lodash/uniqBy';
import { TerminalProcedure } from '../../airport/models/terminal-procedure.model';
var TreeNode = /** @class */ (function () {
    function TreeNode(data, label, children, leaf, expanded) {
        if (children === void 0) { children = []; }
        if (leaf === void 0) { leaf = false; }
        if (expanded === void 0) { expanded = false; }
        this.data = data;
        this.label = label;
        this.children = children;
        this.leaf = leaf;
        this.expanded = expanded;
        this._updated = false;
        this._selected = null;
        this._docs = null;
        this._selectedDocs = null;
        this._size = null;
        this._selectedSize = null;
        this._descendantFiles = null;
        this._descendantProcs = null;
    }
    Object.defineProperty(TreeNode.prototype, "selected", {
        get: function () {
            return this._selected;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeNode.prototype, "docs", {
        get: function () {
            return this._docs;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeNode.prototype, "selectedDocs", {
        get: function () {
            return this._selectedDocs;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeNode.prototype, "size", {
        get: function () {
            return this._size;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeNode.prototype, "selectedSize", {
        get: function () {
            return this._selectedSize;
        },
        enumerable: true,
        configurable: true
    });
    TreeNode.prototype.iterate = function (fn) {
        fn(this);
        if (!this.leaf && this.children && this.children.length) {
            this.children.forEach(function (c) { return c.iterate(fn); });
        }
    };
    TreeNode.prototype.iterateLeaves = function (fn) {
        if (this.leaf) {
            fn(this);
        }
        else {
            (this.children || []).forEach(function (c) { return c.iterateLeaves(fn); });
        }
    };
    TreeNode.prototype.updateTree = function (selectedFiles) {
        this._resetTree();
        this._updateTree(selectedFiles);
    };
    TreeNode.prototype._resetTree = function () {
        this.iterate(function (node) {
            node._updated = false;
            node._descendantFiles = null;
            node._descendantProcs = null;
        });
    };
    TreeNode.prototype._updateTree = function (selectedFiles) {
        if (this._updated) {
            return;
        }
        if (this.leaf) {
            if (this.data !== null && this.data instanceof TerminalProcedure) {
                this._selected = selectedFiles.has(this.data.fullFilename);
                this._docs = 1;
                this._size = this.data.filesize;
                this._selectedDocs = this._selected ? 1 : 0;
                this._selectedSize = this._selected ? this._size : 0;
            }
            else {
                this._selected = false;
                this._docs = 0;
                this._size = 0;
                this._selectedDocs = 0;
                this._selectedSize = 0;
            }
        }
        else {
            this.children.forEach(function (child) { return child._updateTree(selectedFiles); });
            this._selected = this.children.every(function (c) { return c._selected; })
                ? true
                : (this.children.some(function (c) { return c._selected; }) ? null : false);
            this._docs = this.children.reduce(function (prev, curr) { return prev + curr._docs; }, 0);
            this._size = this.children.reduce(function (prev, curr) { return prev + curr._size; }, 0);
            var selectedProcs = this.getUniqueDescendantProcs()
                .filter(function (p) { return selectedFiles.has(p.fullFilename); });
            this._selectedDocs = selectedProcs.length;
            this._selectedSize = selectedProcs.reduce(function (prev, curr) { return prev + curr.filesize; }, 0);
        }
        this._updated = true;
    };
    TreeNode.prototype.getDescendantFiles = function () {
        var _this = this;
        if (this._descendantFiles) {
            return this._descendantFiles;
        }
        if (this.leaf) {
            if (this.data !== null && this.data instanceof TerminalProcedure) {
                return this._descendantFiles = new Set([this.data.fullFilename]);
            }
        }
        else {
            this._descendantFiles = new Set();
            for (var _i = 0, _a = this.children; _i < _a.length; _i++) {
                var child = _a[_i];
                child.getDescendantFiles().forEach(function (proc) {
                    _this._descendantFiles.add(proc);
                });
            }
            return this._descendantFiles;
        }
        return this._descendantFiles = new Set();
    };
    TreeNode.prototype.getDescendantProcs = function (selected) {
        if (selected === void 0) { selected = false; }
        if (this.leaf) {
            if (this.data !== null && this.data instanceof TerminalProcedure) {
                return this._descendantProcs = (this._selected || !selected) ? [this.data] : [];
            }
        }
        else {
            return this._descendantProcs = [].concat.apply([], (this.children || []).map(function (c) { return c.getDescendantProcs(selected); }));
        }
        return this._descendantProcs = [];
    };
    TreeNode.prototype.getUniqueDescendantProcs = function () {
        return uniqBy(this.getDescendantProcs(), function (proc) { return proc.fullFilename; });
    };
    TreeNode.prototype.getSelectedProcs = function () {
        return this.getDescendantProcs(true);
    };
    return TreeNode;
}());
export { TreeNode };
